import React, { useState, useEffect } from "react";
import { Box, Button, Container, Paper, LinearProgress, Typography, Alert } from "@mui/material";
import bkstApi from "../../common/component/api";
import RequestHeader from "../component/RequestHeader";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";

import LineItems from "../../common/component/lineitem/LineItems";
import QuoteFulfillmentEntry from "../../common/component/fulfillment/QuoteFulfillmentEntry";
import GenerateAutoQuotesV3 from "../component/GenerateAutoQuotesV3";
import StoreAvailabilityCalendar from "../../common/StoreAvailabilityCalendar";
import ButtonWithConfirmation from "../../common/component/ButtonWithConfirmation";

export default function AiQuote(props) {
  let location = useLocation();
  const navigate = useNavigate();

  const { siteId, reqId } = useParams();

  const [request, setRequest] = useState("");

  const [storeLocation, setStoreLocation] = useState("");
  const [aiConfig, setAiConfig] = useState("");

  const [items, setItems] = useState("");
  const [fulfillment, setFulfillment] = useState("");

  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    bkstApi(`/admin/site/${siteId}/quote/${reqId}`).then((res) => {
      setRequest(res.data.request);
      setStoreLocation(res.data.storeLocation);
      setAiConfig(res.data.aiConfig);

      setItems([]);
      setFulfillment({
        date: res.data.request.date,
        option: { pickup: {}, delivery: { includeFees: true } }
      });

      setLoading(false);
    });
  }, [reqId, location.key]);

  const rejectAiQuote = () => {
    bkstApi.post(`/admin/site/${siteId}/quote/${reqId}/ai`, { action: "reject" }).then((res) => {
      navigate(`/request/${reqId}`);
    });
  };

  const sendAiQuote = () => {
    let payload = {
      items,
      fulfillment,
      status: "active"
    };

    bkstApi.post(`/admin/site/${siteId}/quote/${reqId}/ai`, { action: "send", quote: payload }).then((res) => {
      navigate(`/request/${reqId}`);
    });
  };

  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Container maxWidth="md">
        <Box py={4}>
          <Box mb={4}>
            <Typography variant="h4">AI-Quote</Typography>
          </Box>
          <RequestHeader request={request} />
          <StoreAvailabilityCalendar storeLocation={storeLocation} date={request.date} />
          <Box p={2} my={2} sx={{ border: "1px solid #ddd" }}>
            {aiConfig?.notes}
          </Box>
          {items.length > 0 && (
            <Box my={4}>
              <LineItems items={items} onChange={(arr) => setItems(arr)} />
              <Box my={4}></Box>
              <Typography variant="overline" color="textSecondary">
                SHIPPING
              </Typography>
              <Paper elevation={0}>
                <Box px={2} pt={3} pb={2}>
                  <QuoteFulfillmentEntry fulfillment={fulfillment} onChange={(o) => setFulfillment(o)} />
                </Box>
              </Paper>
              {errors && errors.length > 0 && (
                <Box my={2}>
                  <Alert severity="error">{errors.join(". ")}</Alert>
                </Box>
              )}
            </Box>
          )}
          <Box my={2} sx={{ display: "flex", gap: "15px" }}>
            <ButtonWithConfirmation copy="Are you sure you want to reject this quote?" onConfirm={rejectAiQuote}>
              <Button color="error" variant="contained" fullWidth>
                REJECT
              </Button>
            </ButtonWithConfirmation>
            {items.length === 0 ? (
              <GenerateAutoQuotesV3
                request={request}
                bakerId={siteId}
                aiConfig={aiConfig}
                onChange={(o) => {
                  let arr = items.filter((o) => +o.price > 0);
                  arr.push(o);
                  setItems(arr);
                }}
              />
            ) : (
              <Button fullWidth variant="contained" color="primary" onClick={sendAiQuote}>
                SEND QUOTE
              </Button>
            )}
          </Box>
        </Box>
      </Container>
    );
  }
}
